module.exports = __webpack_public_path__ + "static/1975-team-26c0ea05ce2376101392e59075f526b2.jpg";